import { useCallback, useEffect, useMemo, useState } from 'react';

import debounce from 'lodash/debounce';

export function useElementLayout(elementRef: React.RefObject<HTMLElement>) {
  const [elementLayout, setElementLayout] = useState({ width: 0, height: 0 });

  const debouncedListener = useMemo(
    () =>
      debounce((entries: ResizeObserverEntry[]) => {
        for (const entry of entries) {
          const { width, height } = entry.contentRect;
          setElementLayout({ width, height });
        }
      }, 60),
    [],
  );

  const listener = useCallback(
    (entries: ResizeObserverEntry[]) => {
      debouncedListener(entries);
    },
    [debouncedListener],
  );

  useEffect(() => {
    if (elementRef.current) {
      const resizeObserver = new ResizeObserver(listener);
      resizeObserver.observe(elementRef.current);

      return () => {
        resizeObserver.disconnect();
        debouncedListener.cancel();
      };
    }
  }, [listener, elementRef, debouncedListener]);

  return elementLayout;
}
